import React from 'react';
import { Star, Check } from 'lucide-react';
export function UpsellSection() {
  return <section className="bg-white py-16 px-4 md:px-8 border-b border-gray-200" data-id="element-217">
      <div className="max-w-4xl mx-auto" data-id="element-218">
        <div className="bg-yellow-50 border-2 border-yellow-400 rounded-2xl p-8 md:p-12 relative overflow-hidden" data-id="element-219">
          <div className="absolute top-0 right-0 bg-yellow-400 text-black font-bold py-1 px-8 transform rotate-45 translate-x-8 translate-y-4 shadow-sm" data-id="element-220">
            MEJOR OPCIÓN
          </div>

          <div className="text-center mb-8" data-id="element-221">
            <div className="inline-flex items-center gap-2 bg-yellow-400 text-black font-bold px-4 py-1 rounded-full mb-4 text-sm uppercase tracking-wide" data-id="element-222">
              <Star className="w-4 h-4 fill-current" data-id="element-223" />
              MÁS POPULAR
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-2" data-id="element-224">
              SUPER MEGA PACK COMPLETO
            </h2>
            <h3 className="text-xl md:text-2xl font-bold text-green-600 mb-8" data-id="element-225">
              CIENCIAS SOCIALES + SISTEMA COMPLETO DE SECUENCIAS Y PROYECTOS
            </h3>
          </div>

          <div className="flex flex-col md:flex-row items-center gap-8 mb-8" data-id="element-226">
            <div className="w-full md:w-1/2" data-id="element-227">
              <img src="https://cdn.magicpatterns.com/uploads/tVuKUmuFdCD287u2U4bGVG/UPSELL_CIENCIAS_SOCIALES_.png" alt="Super Mega Pack Completo" className="w-full rounded-lg shadow-xl hover:scale-105 transition-transform duration-300" data-id="element-228" />
            </div>
            <div className="w-full md:w-1/2" data-id="element-229">
              <p className="text-xl font-bold text-gray-800 mb-6" data-id="element-230">
                5 Cuadernillos completos + 3 Bonos
              </p>
              <ul className="space-y-3 mb-8" data-id="element-231">
                {['Ciencias Sociales completa', 'Sistema completo de secuencias y proyectos', '3 Bonos incluidos', 'Garantía 7 días'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-232">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-233" />
                    <span className="text-gray-700 font-medium" data-id="element-234">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center bg-white p-6 rounded-xl border border-gray-200 shadow-sm" data-id="element-235">
            <p className="text-gray-500 text-lg line-through mb-1" data-id="element-236">
              Valor separado $34.990 ARS
            </p>
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-237">
              <span className="text-5xl md:text-6xl font-black text-green-600" data-id="element-238">
                $24.990
              </span>
              <span className="text-xl font-bold text-gray-500" data-id="element-239">ARS</span>
            </div>
            <p className="text-red-500 font-bold mb-6" data-id="element-240">
              ¡Ahorrás $10.000 ARS más!
            </p>

            <a href="https://mi-tienda-pro-8012.myshopify.com/cart/48253018800347:1" className="block w-full bg-green-600 hover:bg-green-700 text-white text-xl md:text-2xl font-bold py-4 px-6 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 animate-pulse" data-id="element-241">
              👉 SÍ, QUIERO EL SUPER MEGA PACK
            </a>
          </div>
        </div>
      </div>
    </section>;
}